import { render, staticRenderFns } from "./wineOne.vue?vue&type=template&id=0772fe70&scoped=true"
import script from "./wineOne.vue?vue&type=script&lang=js"
export * from "./wineOne.vue?vue&type=script&lang=js"
import style0 from "./wineOne.vue?vue&type=style&index=0&id=0772fe70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772fe70",
  null
  
)

export default component.exports